export default __webpack_public_path__ + "static/media/etavastaanotto-darkblue.c654d5fa.svg";